import React, { useEffect, useRef } from "react";
import PropertyNames from "../PropertyNames";

export function createWebsocketMessage(msgParams) {
  var msg = {};
  msg.object = msgParams.messageType;
  msg.parameters = msgParams.parameters;
  msg.method = msgParams.method;
  msg.instance = msgParams.instance;
  return msg;
}

// converts a DocumentSearchResultRVO to a DocumentRVO
export function convertDocumentRVO(documentResultRVO) {
  return {
    documentID: documentResultRVO.documentId || documentResultRVO.documentID,
    userTitle: documentResultRVO.title || documentResultRVO.userTitle,
    communityId: documentResultRVO.communityId,
  };
}

export function getSearchLanguages(currentUser, appProperties) {
  if (
    currentUser &&
    currentUser.userSettings &&
    Array.isArray(currentUser.userSettings.searchLanguages) &&
    currentUser.userSettings.searchLanguages.length > 0
  ) {
    return currentUser.userSettings.searchLanguages;
  }
  if (appProperties && appProperties[PropertyNames.SEARCH_LANGUAGES]) {
    try {
      return JSON.parse(appProperties[PropertyNames.SEARCH_LANGUAGES]);
    } catch (e) {
      // whatever, just return the default
    }
  }
  return ["en"];
}

export function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(
    () => {
      savedCallback.current = callback;
    },
    [callback]
  );

  // Set up the interval.
  useEffect(
    () => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    },
    [delay]
  );
}
